import React, { FC, useState } from "react";
import { BottomSheet } from "react-spring-bottom-sheet";
import { useCurrency, useCountryShort, useLanguage } from "@/hooks";
import PdpAnalyticsEvent from "@/services/analytics/main/pdp";
import InfoIconGrey from "@/images/info-icon-grey.svg";
import CloseIcon from "@/images/close_icon.svg";
import "react-spring-bottom-sheet/dist/style.css";

const IMAGE_PATTERN = /\.(jpg|jpeg|png|gif|webp|svg)(\?.*)?$/i;

const resolveUrl = (
  url: string,
  language: string,
  amount: string | number,
  currency: string,
  countryShort: string
): string =>
  url
    .replace(/api__language__/g, language)
    .replace(/api__amount__/g, String(amount))
    .replace(/api__currency__/g, currency)
    .replace(/api__countryShort__/g, countryShort.toUpperCase());

const PayLaterOptionItem: FC<any> = ({
  paymentSystemIcon,
  paymentMode,
  normalPrice,
  additionalUrl
}) => {
  const [sheetOpen, setSheetOpen] = useState(false);
  const languageSlug = useLanguage();
  const currencyCode = useCurrency();
  const countryShort = useCountryShort();

  const resolvedUrl = additionalUrl
    ? resolveUrl(
        additionalUrl,
        languageSlug,
        normalPrice ?? 0,
        currencyCode,
        countryShort
      )
    : undefined;
  const isImageUrl = additionalUrl && IMAGE_PATTERN.test(additionalUrl);

  const handleInfoIconClick = () => {
    setSheetOpen(true);
    PdpAnalyticsEvent.paymentMethodInfo({ method: paymentMode });
  };

  const closeButton = (
    <div className="payment_info_close_wrapper">
      <div className="payment_info_close" onClick={() => setSheetOpen(false)}>
        <img src={CloseIcon} alt="close" style={{ width: 12, height: 12 }} />
      </div>
    </div>
  );

  return (
    <div className={paymentMode.toLowerCase()}>
      <div>
        <div className="position-relative payment_option_content">
          <div className="payment_system_icon_wrapper">
            <img
              src={paymentSystemIcon}
              alt="Payment System Icon"
              className="svg-icon payment-system-icon"
            />
          </div>
          {additionalUrl && (
            <div className="info-icon" onClick={handleInfoIconClick}>
              <img src={InfoIconGrey} alt="info" />
            </div>
          )}
        </div>
        <div
          className="touch-detector"
          data-tabby-info="installments"
          data-tabby-language={languageSlug}
        />
      </div>

      {resolvedUrl && (
        <BottomSheet
          open={sheetOpen}
          onDismiss={() => setSheetOpen(false)}
          blocking
          className="payment_info_sheet"
          header={closeButton}
          snapPoints={({ maxHeight }) => maxHeight * 0.85}
          defaultSnap={({ maxHeight }) => maxHeight * 0.85}
          style={{ "--rsbs-overlay-rounded": "8px" } as React.CSSProperties}
        >
          {isImageUrl ? (
            <img
              src={resolvedUrl}
              alt="Payment info"
              style={{ width: "100%", display: "block" }}
            />
          ) : (
            <iframe
              src={resolvedUrl}
              style={{
                border: "none",
                display: "block",
                width: "100%",
                height: "1500px"
              }}
            />
          )}
        </BottomSheet>
      )}
    </div>
  );
};

export default PayLaterOptionItem;
